const TrainingModuleReducer = (state = {}, action) => {
    switch (action.type) {
      case "TRML_DOCS":
        return Object.assign({}, state, {
          TRML: action.data,
        });
      case "DOWNDEL_TRML":
        return Object.assign({}, state, {
          downdeletetrml: action.data,
        });
        case "HIDE_DOWNDEL":
        return Object.assign({}, state, {
          hide: action.data,
        });
        default:
      return state;
  }
};

export default TrainingModuleReducer;